import React from 'react';
import { Drawer, useMediaQuery, useTheme } from '@mui/material';
import { AssistantConversation } from './AssistantConversation';

interface AssistantDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const AssistantDrawer: React.FC<AssistantDrawerProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  React.useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    if (open) {
      document.body.classList.add('assistant-open');
    } else {
      document.body.classList.remove('assistant-open');
    }

    return () => {
      document.body.classList.remove('assistant-open');
    };
  }, [open]);

  return (
    <Drawer
      anchor={isDesktop ? 'right' : 'bottom'}
      open={open}
      onClose={onClose}
      sx={{ zIndex: theme.zIndex.modal + 5 }}
      PaperProps={{
        sx: {
          width: isDesktop ? 'min(640px, 100vw)' : '100%',
          maxHeight: isDesktop ? '100vh' : '85vh',
          borderTopLeftRadius: isDesktop ? 0 : 24,
          borderTopRightRadius: isDesktop ? 0 : 24,
        },
      }}
    >
      <AssistantConversation onClose={onClose} />
    </Drawer>
  );
};
